import ReactNativeForegroundService from '@supersami/rn-foreground-service';

export const isForegroundLocalizationRunning = () => {
  return ReactNativeForegroundService.is_task_running('geolocationTask');
};

export const startForeground = async (action: () => void, delay: number) => {
  await configureForegroundNotifications();
  if (!isForegroundLocalizationRunning()) {
    ReactNativeForegroundService.add_task(action, {
      delay,
      onLoop: true,
      taskId: 'geolocationTask',
      onError: e => console.debug('GeolocationTask Error logging:', e),
    });
  }
};

export const configureForegroundNotifications = async () => {
  await ReactNativeForegroundService.start({
    id: 1244,
    title: 'Soli360',
    message: 'Soporte Geográfico para la fuerza de ventas.',
    icon: 'ic_launcher',
    button: false,
    button2: false,
    buttonText: 'Button',
    button2Text: 'Anther Button',
    buttonOnPress: 'cray',
    mainOnPress: 'main-pressed',
    setOnlyAlertOnce: 'false',
    color: '#000000',
  });
};
